import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { api } from "@/lib/api";
import { FileList, StatusTimeline } from "@/components/dossier-parts";
import { Header } from "@/components/header";
import { Badge, Card, ErrorView, Loading, Row } from "@/components/kit";
import { C, date, eur, PROJECT_LABELS, STATUS_LABELS, statusColor } from "@/lib/format";

export default function DossierScreen() {
  const { id } = useParams();
  const q = useQuery({ queryKey: ["dossier", id], queryFn: () => api(`/recommendations/${id}`) });
  const d = q.data;
  return (
    <div data-testid="agent-dossier-screen" className="flex flex-col">
      <Header title={d ? d.number : "Dossier"} subtitle={d ? `Reçu le ${date(d.created_at)}` : undefined} />
      {q.isLoading ? (
        <Loading />
      ) : q.isError || !d ? (
        <ErrorView message="Dossier introuvable." onRetry={() => q.refetch()} />
      ) : (
        <div className="mx-auto grid w-full max-w-6xl gap-4 p-4 pb-8 md:p-8 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
          <div className="flex flex-col gap-4">
            <Card className="flex flex-col gap-2" style={{ borderColor: statusColor(d.status) }}>
              <p className="t-caption">STATUT ACTUEL</p>
              <p className="t-h1" data-testid="dossier-current-status" style={{ color: statusColor(d.status) }}>{STATUS_LABELS[d.status]}</p>
              {d.commission_amount ? (
                <p data-testid="dossier-commission" className="t-body">
                  Commission : <span className="t-h3 !text-[#27AE60]">{eur(d.commission_amount)}</span>
                </p>
              ) : null}
            </Card>
            <Card>
              <h2 className="t-h3 mb-3">Évolution du dossier</h2>
              <StatusTimeline current={d.status} history={d.status_history} />
            </Card>
          </div>
          <div className="flex flex-col gap-4">
            <Card>
              <h2 className="t-h3 mb-2">Client</h2>
              <Row label="Nom" value={`${d.client.first_name} ${d.client.last_name}`} testID="dossier-client-name" />
              <Row label="Téléphone" value={d.client.phone} />
              <Row label="E-mail" value={d.client.email} />
            </Card>
            <Card>
              <h2 className="t-h3 mb-2">Projet</h2>
              <Row label="Type" value={PROJECT_LABELS[d.project_type]} />
              <Row label="Prestation" value={d.service_type} />
              <Row label="Adresse" value={`${d.address}, ${d.postal_code} ${d.city}`} />
              <Row label="Budget estimatif" value={d.budget ? eur(d.budget) : null} />
              <Row label="Rendez-vous" value={d.rdv_done ? "Réalisé" : "À venir"} />
              {d.contract_amount ? <Row label="Montant signé" value={eur(d.contract_amount)} /> : null}
              <p className="t-label mt-3">Description</p>
              <p className="t-body mt-1 whitespace-pre-line">{d.description}</p>
            </Card>
            <Card>
              <h2 className="t-h3 mb-2">Documents &amp; photos</h2>
              <FileList files={d.files} />
            </Card>
            <Badge label="Dossier suivi par Ma Maison Suivie" color={C.silver} />
          </div>
        </div>
      )}
    </div>
  );
}
